import React from 'react';
const AboutPage: React.FC = () => <div>About Page</div>;
export default AboutPage;